import { useRegion } from './useRegion';
export function useAxis(type) {
  var region = useRegion();
  return region.getAxis(type);
}